/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const diacriticsMap: any = {
  à: 'a',
  á: 'a',
  â: 'a',
  ã: 'a',
  ä: 'a',
  å: 'a',
  ç: 'c',
  è: 'e',
  é: 'e',
  ê: 'e',
  ë: 'e',
  ì: 'i',
  í: 'i',
  î: 'i',
  ï: 'i',
  ñ: 'n',
  ò: 'o',
  ó: 'o',
  ô: 'o',
  õ: 'o',
  ö: 'o',
  ø: 'o',
  ù: 'u',
  ú: 'u',
  û: 'u',
  ü: 'u',
  ý: 'y',
  ÿ: 'y',
  ß: 'ss', // German Eszett

  À: 'A',
  Á: 'A',
  Â: 'A',
  Ã: 'A',
  Ä: 'A',
  Å: 'A',
  Ç: 'C',
  È: 'E',
  É: 'E',
  Ê: 'E',
  Ë: 'E',
  Ì: 'I',
  Í: 'I',
  Î: 'I',
  Ï: 'I',
  Ñ: 'N',
  Ò: 'O',
  Ó: 'O',
  Ô: 'O',
  Õ: 'O',
  Ö: 'O',
  Ø: 'O',
  Ù: 'U',
  Ú: 'U',
  Û: 'U',
  Ü: 'U',
  Ý: 'Y',
  // Add more mappings for other diacritics as needed
};

export const cleanFolderName = (toClean: string): string => {
  try {
    toClean = toClean.trim();
    toClean = toClean.replace(/\s{2,}/gim, ' ');
    toClean = toClean.replace(/\s/gim, '_');
    toClean = toClean.replace(/ü/gm, 'ue');
    toClean = toClean.replace(/Ü/gm, 'Ue');
    toClean = toClean.replace(/ö/gm, 'oe');
    toClean = toClean.replace(/Ö/gm, 'OE');
    toClean = toClean.replace(/ä/gm, 'ae');
    toClean = toClean.replace(/Ä/gm, 'AE');
    toClean = toClean.replace(/ß/gim, 'ss');

    toClean = toClean.replace(/ó/gm, 'o');
    toClean = toClean.replace(/Ó/gm, 'O');
    toClean = toClean.replace(/ø/gm, 'o');
    toClean = toClean.replace(/Ø/gm, 'O');
    toClean = toClean.replace(/é/gm, 'e');
    toClean = toClean.replace(/É/gm, 'e');

    Object.keys(diacriticsMap).forEach((key) => {
      toClean = toClean.replace(new RegExp(key, 'gm'), diacriticsMap[key]);
    });

    toClean = toClean.replace(/[^a-z0-9_-]/gim, '');

    return toClean;
  } catch (e) {
    return '_';
  }
};
